<template>
  <div class="team-manage">
    <el-card>
      <div slot="header">
        <span>团队分组管理</span>
        <el-button type="primary" size="small" style="float:right" @click="openAdd('')">新增分组</el-button>
      </div>

      <el-table :data="groupList" border stripe v-loading="loading">
        <el-table-column prop="id" label="ID" width="60"></el-table-column>
        <el-table-column prop="groupName" label="分组名称" width="160"></el-table-column>
        <el-table-column label="绑定视频号" min-width="350">
          <template slot-scope="scope">
            <el-tag v-for="vid in scope.row.videoIds" :key="vid" size="small" style="margin-right:4px;margin-bottom:2px">{{ vid }} <span style="color:#909399">({{ getVideoName(vid) }})</span></el-tag>
            <span v-if="!scope.row.videoIds || scope.row.videoIds.length===0" style="color:#999">暂无</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="160">
          <template slot-scope="scope">{{ (scope.row.createTime || '').replace('T', ' ') }}</template>
        </el-table-column>
        <el-table-column label="操作" width="140">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" style="color:#f56c6c" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="editingId ? '编辑分组' : '新增分组'" :visible.sync="showDialog" width="550px">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="分组名称" prop="groupName">
          <el-input v-model="form.groupName" placeholder="请输入分组名称"></el-input>
        </el-form-item>
        <el-form-item label="绑定视频号">
          <el-radio-group v-model="videoInputMode" size="small" style="margin-bottom:8px">
            <el-radio-button label="select">下拉选择</el-radio-button>
            <el-radio-button label="manual">手动输入</el-radio-button>
          </el-radio-group>
          <el-select
            v-if="videoInputMode === 'select'"
            v-model="form.videoIds"
            multiple
            filterable
            placeholder="选择视频号"
            style="width:100%"
            collapse-tags>
            <el-option
              v-for="v in allVideos"
              :key="v.videoId"
              :label="v.videoId"
              :value="v.videoId">
              <span style="float:left">{{ v.videoId }}</span>
              <span style="float:right;color:#8492a6;font-size:13px">{{ v.videoName || '-' }}</span>
            </el-option>
          </el-select>
          <div v-else>
            <el-tag v-for="(vid,idx) in form.videoIds" :key="idx" closable @close="removeVideo(idx)" style="margin-right:5px;margin-bottom:5px">{{ vid }}</el-tag>
            <el-input v-if="videoInputVisible" ref="videoInput" v-model="videoInputValue" size="small" style="width:130px" @keyup.enter.native="addVideo" @blur="addVideo"></el-input>
            <el-button v-else size="small" @click="showVideoInput">+ 添加视频号</el-button>
          </div>
          <div v-if="form.videoIds.length>0" style="margin-top:6px;color:#909399;font-size:12px">
            已选 {{ form.videoIds.length }} 个视频号
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showDialog = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api'
export default {
  name: 'TeamManage',
  data() {
    return {
      groupList: [],
      allVideos: [],
      loading: false,
      showDialog: false,
      editingId: null,
      videoInputMode: 'select',
      form: { groupName: '', videoIds: [] },
      rules: { groupName: [{ required: true, message: '请输入分组名称', trigger: 'blur' }] },
      videoInputVisible: false,
      videoInputValue: ''
    }
  },
  mounted() {
    this.loadData()
    api.getDistinctVideos().then(res => { this.allVideos = res.data || [] })
  },
  methods: {
    loadData() {
      this.loading = true
      api.teamList().then(res => { this.groupList = res.data || [] }).finally(() => { this.loading = false })
    },
    getVideoName(videoId) {
      const v = this.allVideos.find(item => item.videoId === videoId)
      return v ? v.videoName : '-'
    },
    openAdd(parentId) {
      this.editingId = null
      this.videoInputMode = 'select'
      this.form = { groupName: '', videoIds: [] }
      this.showDialog = true
    },
    openEdit(row) {
      this.editingId = row.id
      this.videoInputMode = 'select'
      this.form = { groupName: row.groupName, videoIds: [...(row.videoIds || [])] }
      this.showDialog = true
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        if (this.editingId) {
          api.teamUpdate({ id: this.editingId, ...this.form }).then(() => {
            this.$message.success('修改成功'); this.showDialog = false; this.loadData()
          })
        } else {
          api.teamCreate(this.form).then(() => {
            this.$message.success('创建成功'); this.showDialog = false; this.loadData()
          })
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确认删除分组 "' + row.groupName + '" ?', '提示', { type: 'warning' }).then(() => {
        api.teamDelete(row.id).then(() => { this.$message.success('删除成功'); this.loadData() })
      }).catch(() => {})
    },
    showVideoInput() {
      this.videoInputVisible = true
      this.$nextTick(() => { this.$refs.videoInput && this.$refs.videoInput.focus() })
    },
    addVideo() {
      const val = this.videoInputValue.trim()
      if (val && !this.form.videoIds.includes(val)) {
        this.form.videoIds.push(val)
      }
      this.videoInputVisible = false
      this.videoInputValue = ''
    },
    removeVideo(idx) {
      this.form.videoIds.splice(idx, 1)
    }
  }
}
</script>
